import React, { useEffect, useState } from "react";
import getAllEquipment from "./AddEquipment"; // Adjust path as needed
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { Typography, CircularProgress } from "@mui/material";

function CheckedOut() {
  const [equipment, setEquipment] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchEquipmentData() {
      try {
        const data = await getAllEquipment();
        // Filter to show only items that are not damaged and are 'atWarehouse' (atWarehouse === true)
        const filteredData = (data || []).filter(
          (item) => item.Damaged === false && item.atWarehouse === false
        );
        const sortedData = filteredData.sort((a, b) => a.id - b.id); // Sort by id in ascending order
        setEquipment(sortedData);
      } catch (error) {
        console.error('Error fetching equipment data:', error);
      } finally {
        setLoading(false);
      }
    }
    fetchEquipmentData();
  }, []);

  if (loading) {
    return <div id="progress"><CircularProgress /></div>;
  }

  // Only include the 'id', 'name', and 'cost' columns
  const headers = ['id', 'name', 'cost'];
  const itemCount = equipment.length; // Count of items in the filtered equipment list

  return (
    <div>
      <Typography align="center" variant="h4" component="div" sx={{ flexGrow: 1, m: 2 }}>
        Checked-out Equipment List
      </Typography>
      <Typography align="center" variant="subtitle1" component="div" sx={{ mb: 2 }}>
        Total checked-out Items: {itemCount}
      </Typography>
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              {headers.map((header) => (
                <TableCell key={header}>
                  {header.charAt(0).toUpperCase() + header.slice(1)}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {equipment.map((item) => (
              <TableRow key={item.id}>
                {headers.map((header) => (
                  <TableCell key={header}>
                    {header === 'cost' ? (
                      // Format cost as currency
                      `$${item[header]?.toFixed(2) || 'N/A'}`
                    ) : (
                      item[header] !== undefined ? item[header] : 'N/A'
                    )}
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
}

export default CheckedOut;
